import { fetchWithAuth } from './authService';
import { throwApiError } from './apiError';

const USE_MOCK = false;
const IS_MASTERED = false;

export const getStudyState = async (historyId) => {
  if (USE_MOCK) {
    if (IS_MASTERED) {
      const { mockStudyStateMastered } = await import('../data/mockStudyState');
      return mockStudyStateMastered;
    }

    const { mockStudyStateLearn } = await import('../data/mockStudyState');
    return mockStudyStateLearn;
  }

  const response = await fetchWithAuth(`/api/study/${historyId}`);
  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
};

export const submitStudyAnswer = async (cardId, answer) => {
  if (USE_MOCK) {
    const { mockStudyStateReview } = await import('../data/mockStudyState');
    return mockStudyStateReview;
  }

  const response = await fetchWithAuth(`/api/study/${cardId}`, {
    method: 'POST',
    body: JSON.stringify({ answer }),
    headers: { 'Content-Type': 'application/json' }
  });

  if (response && response.ok) {
    return await response.json();
  }

  await throwApiError(response);
};
